/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Default_Catch_Boundary_TitleInputs */

const en_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const de_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen`)
};

const pt_br2_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado`)
};

const tr_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir şeyler yanlış gitti`)
};

const zh_cn2_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出错了`)
};

const zh_hk2_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生錯誤`)
};

const ko_kr2_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문제가 발생했습니다`)
};

const ru_ru2_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так`)
};

const es_419_components_default_catch_boundary_title = /** @type {(inputs: Components_Default_Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Components_Default_Catch_Boundary_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_default_catch_boundary_title = /** @type {((inputs?: Components_Default_Catch_Boundary_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Default_Catch_Boundary_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_default_catch_boundary_title(inputs)
	if (locale === "de") return de_components_default_catch_boundary_title(inputs)
	if (locale === "pt-BR") return pt_br2_components_default_catch_boundary_title(inputs)
	if (locale === "tr") return tr_components_default_catch_boundary_title(inputs)
	if (locale === "zh-CN") return zh_cn2_components_default_catch_boundary_title(inputs)
	if (locale === "zh-HK") return zh_hk2_components_default_catch_boundary_title(inputs)
	if (locale === "ko-KR") return ko_kr2_components_default_catch_boundary_title(inputs)
	if (locale === "ru-RU") return ru_ru2_components_default_catch_boundary_title(inputs)
	return es_419_components_default_catch_boundary_title(inputs)
});